import PropTypes from 'prop-types';
import React from 'react';

const SaveConfirmation = ({ success, text }) => (
	<div className={`common-ui-save-confirmation ${success ? '' : 'failed'}`}>
		{success && <span className="check-icon" alt="check icon" />}
		<p className="label">{text}</p>
	</div>
);

export default SaveConfirmation;

SaveConfirmation.propTypes = {
	success: PropTypes.bool,
	text: PropTypes.string,
};
